export const status = {
    IN_PROGRESS: 0,
    SUCCESS: 1,
    FAILURE: 2
};

// Explicit deal-flow modes used by /deals page navigation state.
// Drives whether a draft is created fresh, hydrated by id, or treated as edit/copy.
export const DealMode = {
    CREATE: 'create',
    DRAFT: 'draft',
    EDIT: 'edit',
    COPY: 'copy',
};

// 15 minutes — must match backend EDIT_GRACE_WINDOW_MS in merchants.service.ts
export const DEAL_EDIT_GRACE_WINDOW_MS = 15 * 60 * 1000;

// Influencer-side proposal flow modes.
// CREATE  — fresh new proposal from scratch.
// DRAFT   — resuming a saved local draft.
// COPY    — using a rejected proposal as a template for a brand-new submission
//           (the rejected proposal is NOT mutated; a completely new proposal is created).
export const InfluencerDealMode = {
    CREATE: 'create',
    DRAFT:  'draft',
    COPY:   'copy',
};
